// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3-04v","inner":"Footer_inner__xZhtF","nextIcon":"Footer_nextIcon__FYDho","innerLeft":"Footer_innerLeft__w4DPr"};